import React from "react"

import { graphql, useStaticQuery } from "gatsby"

export default function usePagesImages(filename = "") {
  return useStaticQuery(graphql`
    query {
      allFile(filter: { relativePath: { regex: "/pages/" } }) {
        nodes {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
              originalName
            }
          }
          relativePath
        }
      }
    }
  `)?.allFile.nodes.filter(
    e => e.childImageSharp.fluid.originalName === filename
  )?.[0].childImageSharp.fluid
}
